import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isNumber',
    standalone: false
})
export class IsNumberPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return !isNaN(value);
  }

}
